import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { NewsEvent } from '@/modules/calendar/model/calendar/news-event';
import { articleApi } from '@/modules/articles/export';

export function CoverageBadge({
  event,
  coverageType,
  className,
  label,
}: {
  event: NewsEvent;
  coverageType: string;
  className: string;
  label: string;
}) {
  const [hasCoverage, setHasCoverage] = useState(false);
  useEffect(() => {
    if (event.coverageSeries) {
      let coverageSeries;
      if (coverageType === 'PREVIEW') {
        coverageSeries = event.coverageSeries.filter(
          value => value.coverageType.code === 'PREVIEW',
        );
      } else if (coverageType === 'REVIEW') {
        coverageSeries = event.coverageSeries.filter(value => value.coverageType.code === 'REVIEW');
      } else {
        coverageSeries = event.coverageSeries.filter(
          value => value.coverageType.code === 'RELATED',
        );
      }
      Promise.all(
        coverageSeries.map(value => {
          const eventDate = dayjs(event.date);
          const daysAfter = value.coverageType.code === 'PREVIEW' ? -7 : 0;
          const daysBefore = value.coverageType.code === 'PREVIEW' ? 0 : 7;
          return articleApi.getArticlesBySection(undefined, {
            includeGenres: [value.coverageQCode],
            updatedAfter: eventDate.add(daysAfter, 'day').valueOf(),
            updatedBefore: eventDate.add(daysBefore, 'day').valueOf(),
          });
        }),
      ).then(articlePages => {
        if (articlePages && articlePages.some(page => page.content.length > 0)) {
          setHasCoverage(true);
        }
      });
    }
  }, [event, coverageType]);

  let hasCoverageType = false;
  if (event.coverageSeries) {
    hasCoverageType = hasCoverage;
  }
  if (event.coverage) {
    hasCoverageType =
      hasCoverageType || event.coverage.some(value => value.coverageType.name === coverageType);
  }
  if (!hasCoverageType) {
    return <></>;
  }

  return <span className={`badge badge-pill small text-base-light ${className}`}>{label}</span>;
}
